import { lazy, useRef, Suspense } from "react";
import SalzabbauRoomShell from "../Themes/Salzabbau/SalzabbauRoomShell";
import HolzarbeitRoomShell from "../Themes/Holzarbeit/HolzarbeitRoomShell";
import KlimaRoomShell from "../Themes/Klima/KlimaRoomShell";
import HandelswegeRoomShell from "../Themes/Handelswege/HandelswegeRoomShell";
import MenschenRoomShell from "../Themes/Menschen/MenschenRoomShell";
import MDRRoomShell from "../Themes/MuseenDerRegion/MDRRoomShell";
import * as THREE from "three";
import GlbLoader from "../Utils/GlbLoader";
import { stateWallPush, stateNavigation } from "../store";
import { useState } from "react";
import { useSnapshot } from "valtio";
import CheckInAreaEntryRoom from "../Utils/CheckInAreaEntryRoom";
import { stateInAreaRooms , stateMemory} from "../store";
import { useGLTF } from "@react-three/drei";
import { useTexture } from "@react-three/drei";
import { useEffect } from "react";
import { disposeGLTF } from "../Utils/disposeGLTF";
import { assignMaterialToObjects } from "../Utils/AssignMaterialToObject";

const Handelswege = lazy(()=> import ("../Themes/Handelswege/Handelswege"))
const Holzarbeit = lazy(()=> import ("../Themes/Holzarbeit/Holzarbeit"))
const Klima = lazy(()=> import ("../Themes/Klima/Klima"))
const Menschen = lazy(()=> import ("../Themes/Menschen/Menschen"))
const MuseenDerRegion = lazy(()=> import ("../Themes/MuseenDerRegion/MuseenDerRegion"))
const Salzabbau = lazy(()=> import ("../Themes/Salzabbau/Salzabbau"))

// Preload all room GLBs at startup (43–234 KB each) so they're cached when a door opens.
useGLTF.preload("../models/Museum01/MuseenDerRegion.glb");
useGLTF.preload("../models/Museum01/Holzarbeit.glb");
useGLTF.preload("../models/Museum01/Klima.glb");
useGLTF.preload("../models/Museum01/Showroom.glb");
useGLTF.preload("../models/Museum01/Handelswege.glb");
useGLTF.preload("../models/Museum01/Menschen.glb");



export default function EntryRoom() {



  const snapInAreaRooms = useSnapshot(stateInAreaRooms);
  const snapMuseumPoints = useSnapshot(stateWallPush);
  const snapStateNavigation = useSnapshot(stateNavigation);
  const entryRoomRef = useRef();

  const { entryRoomModel} = GlbLoaderEntryRoom();





  return (
    <>
 <CheckInAreaEntryRoom
       squareA={170}
      squareB={170}
      position={[0, 0, 0]}
      ></CheckInAreaEntryRoom> 


<primitive
        ref={entryRoomRef}
        object={entryRoomModel.scene}
        scale={1}
        visible={snapInAreaRooms.inAreaRoomEntryRoom}
        
      /> 




      {/* Room shells — always mounted, visible prop controls rendering and texture streaming */}
      <Suspense fallback={null}><MDRRoomShell visible={snapMuseumPoints.visibleThemeIndex === 0 || snapStateNavigation.waypointSetId === "ThemeM_MuseenDerRegion"} /></Suspense>
      <Suspense fallback={null}><HolzarbeitRoomShell visible={snapMuseumPoints.visibleThemeIndex === 1} /></Suspense>
      <Suspense fallback={null}><KlimaRoomShell visible={snapMuseumPoints.visibleThemeIndex === 2} /></Suspense>
      <Suspense fallback={null}><SalzabbauRoomShell visible={snapMuseumPoints.visibleThemeIndex === 3} /></Suspense>
      <Suspense fallback={null}><HandelswegeRoomShell visible={snapMuseumPoints.visibleThemeIndex === 4} /></Suspense>
      <Suspense fallback={null}><MenschenRoomShell visible={snapMuseumPoints.visibleThemeIndex === 5} /></Suspense>

      {/* Content — only mounts when room is active; room shell is already visible so no fallback needed */}
      {(snapMuseumPoints.visibleThemeIndex === 0 || snapStateNavigation.waypointSetId === "ThemeM_MuseenDerRegion") && <Suspense fallback={null}><MuseenDerRegion /></Suspense>}
      {snapMuseumPoints.visibleThemeIndex === 1 && <Suspense fallback={null}><Holzarbeit /></Suspense>}
      {snapMuseumPoints.visibleThemeIndex === 2 && <Suspense fallback={null}><Klima /></Suspense>}
      {snapMuseumPoints.visibleThemeIndex === 3 && <Suspense fallback={null}><Salzabbau /></Suspense>}
      {snapMuseumPoints.visibleThemeIndex === 4 && <Suspense fallback={null}><Handelswege /></Suspense>}
      {snapMuseumPoints.visibleThemeIndex === 5 && <Suspense fallback={null}><Menschen /></Suspense>}
    </>
  );
}





const GlbLoaderEntryRoom = () => {

  const [modelLoadCount, setModelLoadCount] = useState(0);

 const snapStateMemory = useSnapshot(stateMemory)
 const snapInAreaRooms = useSnapshot(stateInAreaRooms)
const {imperfectionRoughMap , waterColorMap} = GlbLoader()

//  const landscape = useLoader(GLTFLoader,"../models/Museum01/MDR/Landscape.glb");
  // const themeMonitor = useLoader(GLTFLoader,
  //   "../models/EntryRoom/ThemeWalls/ThemeMonitor.glb",incrementLoadCount
  // );


  const whiteTransMaterial = new THREE.MeshBasicMaterial({
   
    color: "white",
    transparent: true,
    opacity: 0.35,
  
   
  });
  




  const [
   

    entryRoomFloorAOMap,
  

  
  
  ] = [
   
    "entryRoomFloorAO.jpg",

   

  
  
  
  
  ].map((filename) => !snapStateMemory.memoryLowDevice ? useTexture(`../overallTextures/EntryRoom/${filename}`) : useTexture(`../overallTextures/EntryRoom/LOW/${filename}`));








  // Now you can use memoizedArray in your component


  useEffect(() => {

    return () => {

      [

        entryRoomFloorAOMap,
  
       
      ].forEach(texture => {
    
        if (texture && texture.dispose) {
          texture.dispose();
        }
      });
    };
  }, [snapInAreaRooms.inAreaRoomEntryRoom]);

  

const [


  entryRoomModel,

  
] = useGLTF([

 
  "../models/EntryRoom/EntryRoom.glb",

 
])



    


// Usage in useEffect
useEffect(() => {

 if(!snapInAreaRooms.inAreaRoomEntryRoom){
  disposeGLTF([

    entryRoomModel.scene,

  ]);
}
  // Cleanup function to dispose of GLTF scenes
  return () => {
  
    disposeGLTF([

      entryRoomModel.scene,

 
    ]);
  };
}, [snapInAreaRooms.inAreaRoomEntryRoom]);
 
 

 
  // InfoTextMap.flipY = false;
  //TEXTURE LOADING

  //AO-ma
  entryRoomFloorAOMap.channel = 1;

  entryRoomFloorAOMap.flipY = false;
  entryRoomFloorAOMap.colorSpace = THREE.SRGBColorSpace;



  //Textures Overall





  const blackMattFloorMaterial = new THREE.MeshStandardMaterial({
    roughness: 0.8,
    color: "#181818",
    metalness: 0,
    // map:   entryRoomFloorAOMap,
    roughnessMap: imperfectionRoughMap,
    aoMap: entryRoomFloorAOMap,

  });






  const blueGlasClear = new THREE.MeshStandardMaterial({
    // map: waterColorMap,
    map: waterColorMap,
    // normalMap: waterTileNormalMap,
    // // metalness: 1,
    // roughness: 0.01,
    transparent: true,
    opacity: 0.6,
  });


  const blackMattFloorMaterialGlossy = new THREE.MeshStandardMaterial({
    roughness: 0.05,
    color: "#181818",
    metalness: 0,
    // map:   entryRoomFloorAOMap,
    roughnessMap: imperfectionRoughMap,
    aoMap: entryRoomFloorAOMap,
    // aoMapIntensity: 1,
  });


  //ASSIGNMENT

  useEffect(() => {

    assignMaterialToObjects(entryRoomModel.scene,["Object2963"],blackMattFloorMaterialGlossy);
    assignMaterialToObjects(entryRoomModel.scene,[ "dachGlas"],blueGlasClear);
    assignMaterialToObjects(entryRoomModel.scene,["Floor03", "Floor02", "Floor01"],blackMattFloorMaterial);
    // assignMaterialToObjects(entryRoomModel.scene, ["Rahmen"], rahmenMaterial);

    assignMaterialToObjects(entryRoomModel.scene, ["iAreaLines"], whiteTransMaterial);
   
    
  }, []);


  return {
    entryRoomModel,

   

  
  };
};




